import axios from "axios";
import { baseURL } from "./api";

// /health is served at the API's root, not under /api/v1 — the configured
// axios instance's baseURL can't reach it, so this resolves the origin
// directly (e.g. https://api.ovend.ng/health).
const HEALTH_URL = `${new URL(baseURL).origin}/health`;

export const getSystemHealth = async () => {
  try {
    const { data } = await axios.get(HEALTH_URL);
    return data;
  } catch (e) {
    return null;
  }
};
